// extracted by mini-css-extract-plugin
export var active = "_ff-c";
export var compactArrow = "_ff-5";
export var container = "_ff-0";
export var dot = "_ff-b";
export var dotContainer = "_ff-a";
export var hoverArrowButton = "_ff-7";
export var hoverArrowContainer = "_ff-6";
export var leftHoverArrowContainer = "_ff-8 _ff-6";
export var rightHoverArrowContainer = "_ff-9 _ff-6";
export var slide = "_ff-4";
export var sliderContainer = "_ff-1";
export var sliderContainerVisibleOverflow = "_ff-2";
export var sliderOverflow = "_ff-3";
export var vignetteBoth = "_ff-f";
export var vignetteLeft = "_ff-e";
export var vignetteRight = "_ff-d";